export const GET_CONSUMPTION_REQUEST = "GET_CONSUMPTION_REQUEST";
export const GET_CONSUMPTION_SUCCESS = "GET_CONSUMPTION_SUCCESS";
export const GET_CONSUMPTION_FAILURE = "GET_CONSUMPTION_FAILURE";

export const DOWNLOAD_CONSUMPTION_REQUEST = "DOWNLOAD_CONSUMPTION_REQUEST";
export const DOWNLOAD_CONSUMPTION_SUCCESS = "DOWNLOAD_CONSUMPTION_SUCCESS";
export const DOWNLOAD_CONSUMPTION_FAILURE = "DOWNLOAD_CONSUMPTION_FAILURE";
